const baseStyles = {
    headCells: {
        style: {
            fontSize: '11px',
            width: '100%'
        }
    },
    headRow: {
        style: {
            minHeight: '15px',
            borderBottomWidth: '1px',
            borderBottomStyle: 'solid'
        },
        denseStyle: {
            minHeight: '15px'
        }
    },
    rows: {
        style: {
            placeItems: 'center',
            minHeight: '15px',
            fontSize: '11px',
            fontFamily: 'sans-serif',
            cursor: 'pointer'
        }
    },
    noData: {
        style: {
            color: '$primary',
            backgroundColor: '$primary'
        }
    }
}

export const customStyles = {
    ...baseStyles,
    cells: {
        style: {
            padding: '5px 10px 5px 20px !important',
            minHeight: '1.5rem',
            height: 'auto !important'
        }
    }
}

export const customExpandableStyles = {
    ...baseStyles,
    cells: {
        style: {
            padding: '0px 10px 0px 10px !important',
            height: '2.2rem !important'
        }
    }
}

export const customMiniStyles = {
    ...baseStyles,
    cells: {
        style: {
            padding: '0px 0px 0px 20px !important',
            height: '2.5em !important'
        }
    }
}
